module.exports = __webpack_public_path__ + "img/collect.ef893f52.svg";